import { Navigate } from 'react-router-dom'

export default function RequestAccessPage() {
  return <Navigate to="/auth/signup" replace />
}
